<template>
  <div id="nega" class="mainnega">
    <div>
      <p class="mb-0 text-center" style="font-size:30px;">ネガティブ・ポジティブ反応</p>
      <p class="pl-6 mb-0" style="font-size:15px;">{{$t('アイデア')}}の内容について、ネガティブ・ポジティブ投稿の割合を示しています。</p>
    </div>
    <div v-if="nega_posi_all">
      <v-row class="px-2">
        <v-col cols="12" sm="4">
          ネガティブ・ポジティブ比率↓
          <NegaPosiDoughnut
            :chart-data="chartDataAll"
            :options="chartOptions"
            style="height:300px!important; width:200px!important;">
          </NegaPosiDoughnut>
        </v-col>
        <v-col cols="12" sm="8">
          <p>ネガティブ・ポジティブ意見例</p>
          <div>
            <div><v-icon>mdi-emoticon-excited-outline</v-icon><span style='color: rgba(65,184,131);'>ベストポジティブ意見</span>:</div>
            <p v-for="(posi_cont, index) in maxposi_cont" :key="index">第{{index+1}}位: <span class="text-decoration-underline">{{posi_cont}}</span></p>
          </div>
          <div>
            <div><v-icon>mdi-emoticon-cry-outline</v-icon><span  style='color: rgba(228,102,81,0.85);'>ベストネガティブ意見</span>:</div>
            <div v-for="(nega_cont, index) in maxnega_cont" :key="index">第{{index+1}}位: <span class="text-decoration-underline">{{nega_cont}}</span></div>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="dash">
        <v-col cols="12">
            ポジティブワードクラウド↓
          <MakeWordCloud :word_dict="word_dict_posi" :lidid="lidid" :height="'500px'" :width="'500px'" :comment="false"> </MakeWordCloud>
            ネガティブワードクラウド↓
          <MakeWordCloud :word_dict="word_dict_nega" :lidid="lidid" :height="'500px'" :width="'500px'" :comment="false"> </MakeWordCloud>
        </v-col>
      </v-row>
    </div>
    <div v-else :style="`display:flex; justify-content:center; align-items:center; height:400px`">
      <p style="font-size:20px;">データが存在しないか、処理中です。</p>
    </div>
 
    
  </div>
</template>
 
<script>
//:fontSizeMapper="fontSizeMapper"
//v-show="isShow[trueorfalse]"
//:spiral="rectangular" or "archimedian"

//cloudWordsはデータ結果を入力する


import NegaPosiDoughnut from '../../components/idea/NegaPosiDoughnut.vue';
import MakeWordCloud from '../../components/idea/MakeWordCloud.vue';


export default( {
    name: 'MakeNegaPosiChart',
    props: ['nega_posi_all', 'word_dict_posi', 'word_dict_nega', 'maxposi_cont', 'maxnega_cont', 'dash', 'lidid'],
    components: {
        NegaPosiDoughnut,
        MakeWordCloud,
    },
    data() {
        return {
            //nega_posi_all : [ {'score':11,'number':5}, {'score':11,'number':10} ],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false
            },
            chartDataAll:{}
        }
    },
    computed:{
    },
    created () {
        //console.log("dssds",this.nega_posi_all)
        //console.log(this.maxposi_cont)
        // var parsedObj = JSON.parse(JSON.stringify(this.nega_posi_all[0]))
        // //console.log(parsedObj)
        if (this.nega_posi_all) {
          let posiScore = this.nega_posi_all.POSITIVE["number"]
          let negaScore = this.nega_posi_all.NEGATIVE["number"]
          let sum = posiScore+negaScore
          posiScore = Math.round(100 * posiScore/sum)
          negaScore = 100 - posiScore
          this.chartDataAll.labels = ['ポジティブ', 'ネガティブ'];
          this.chartDataAll.datasets = [
              {
                  backgroundColor: ['rgba(65,184,131, 0.85)', 'rgba(228,102,81,0.85)'],
                  data: [posiScore, negaScore]
              }
          ]
        }
        //console.log("dssds",this.chartDataAll)
    },
})
</script>
<style scoped>
</style>